module.exports = __webpack_public_path__ + "img/logo.785b4d73.jpeg";